import type { ComponentProps } from "react";
import CommentsContent from "src/components/NewComponents/Exam/OptionDetails/Comments/CommentsContent";
import {
	useAddForumComment,
	useRemoveForumComment,
	useToggleForumCommentLike,
} from "src/hooks/useComments";

interface ForumCommentContentProps {
	options?: Record<string, unknown>;
	parentComment?: { id: string | number };
	[key: string]: unknown;
}

export function ForumCommentContent(props: ForumCommentContentProps) {
	const { mutateAsync: addComment } = useAddForumComment() as unknown as {
		mutateAsync: (params: Record<string, unknown>) => Promise<unknown>;
	};
	const { mutateAsync: removeComment } = useRemoveForumComment() as unknown as {
		mutateAsync: (params: Record<string, unknown>) => Promise<unknown>;
	};
	const { mutateAsync: toggleLike } =
		useToggleForumCommentLike() as unknown as {
			mutateAsync: (params: Record<string, unknown>) => Promise<unknown>;
		};

	const onAddComment = async (values: Record<string, unknown>) => {
		await addComment({
			...values,
			options: props.options,
		});
	};

	const onToggleLike = async (values: Record<string, unknown>) => {
		await toggleLike({
			...values,
			...(props.parentComment
				? {
						parentId: props.parentComment.id,
					}
				: {}),
		});
	};

	const onRemoveComment = async (params: Record<string, unknown>) => {
		await removeComment({
			...params,
			...(props.parentComment
				? {
						parentId: props.parentComment.id,
					}
				: {}),
		});
	};

	return (
		<CommentsContent
			{...(props as unknown as ComponentProps<typeof CommentsContent>)}
			onAddComment={onAddComment}
			onRemoveComment={onRemoveComment}
			onToggleLike={onToggleLike}
		/>
	);
}
